/**
 * Streamax dashcams are reported by Fusca (`/devices`) — and surfaced as `deviceModel` through the
 * GraphQL BFF — as the `ADPLUS` model family, e.g. "ADPLUS20-DASHCAM". The suffix after the family
 * name varies per model, so match on the family, case-insensitively.
 */
const STREAMAX_DEVICE_MODEL_FAMILY = 'ADPLUS';

export const isStreamaxDeviceModel = (deviceModel?: string | null): boolean => deviceModel?.toUpperCase().includes(STREAMAX_DEVICE_MODEL_FAMILY) ?? false;
